import Label from "components/general/Label"
import { waringIcon } from "./Icons"

export function ColumnPty({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-5',
    label = '',
    accessor = 'pty',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Pty',
            remove:remove,
            Cell: (props) => {
                return props.cell.row.original?.pty ? waringIcon : ''
            }
        }
    )
}
